<template>
  <div class="modal fade" ref="mdlAutoconfig" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog"  aria-hidden="false">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content" style="border:none">
        <div class="modal-header bg-success">
          <h5 class="modal-title text-white">
            Opciones de descarga del autoconfig para 
            <span class="fw-bold">{{ router.nombre }}</span>
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p>
            <strong>
              <i class="mdi mdi-console-line text-dark"></i> Descarga el 
              <code class="text-primary">autoconfig.rsc</code> del 
              <span class="text-success fw-bold">
                {{ router.nombre }}
              </span>
                desde tu terminal con el siguiente comando:
            </strong>
          </p>

          <div class="position-relative">
            <div class="bg-light rounded text-dark overflow-auto pe-5" style="max-height: 200px;">
              <pre id="comando-autoconfig" class="m-0 p-3 pe-5">{{ comando }}</pre>
            </div>
            <button @click="copiarComando()" class="btn btn-sm btn-success position-absolute top-0 end-0 m-2">
              <i class="mdi mdi-content-copy"></i> Copiar
            </button>
          </div>

          <hr class="my-4">

          <div class="alert alert-warning">
            <i class="mdi mdi-help-circle-outline text-warning"></i>
            <strong>¿Cómo ejecutar el comando en un router MikroTik?</strong>
            <ul class="mt-2 mb-0">
              <li>
                Accede a tu router MikroTik (en este caso, <strong>{{ router.nombre }}</strong>) 
                mediante <strong>Winbox</strong>, <strong>WebFig</strong> o por <strong>SSH</strong>.
              </li>
              <li>Abre la terminal del router (puedes hacer clic en "New Terminal" en Winbox).</li>
              <li>Regresa a esta ventana y haz clic en el botón <strong>“Copiar”</strong> sobre el comando de arriba.</li>
              <li>Pega el comando en la terminal del router y presiona <kbd>Enter</kbd>.</li>
              <li>Después de eso, tu router ya estará enlazado a <strong>ArgusBlack</strong>.</li>
            </ul>
          </div>

          <hr class="my-4">

          <p class="mt-4">
            <strong>
              <i class="mdi mdi-zip-box text-dark"></i> 
              O descarga el archivo comprimido con el siguiente botón:
            </strong>
          </p>

          <button
            class="btn btn-success"
            @click="autoconfig()"
          >
            <i class="mdi mdi-download"></i> Descargar autoconfig.rsc.zip
          </button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouterSrv from '@/services/RouterSrv.js'
import Modal from 'bootstrap/js/dist/modal'
import API from '@/API.js'

export default {
  name: 'MdlAutoconfig',
  data() {
    return {
      id_router: null,
      router: {
        id: null,
        nombre: '',
        fecha_creacion: '',
        _d: ''
      },
      comando: ''
    }
  },
  methods: {
    autoconfig: function() {
      let tk = localStorage.getItem('argusblack.token')
      let router = this.router
      window.open(`${API}/routers/${router.id}/autocfg?_tk=${tk}`, '_blank')
    },

    mostrar(idRouter) {
      var self = this

      self.id_router = idRouter

      self.cargarRouter(function() {
        self.generarComando()
      })
      var modal = new Modal(this.$refs.mdlAutoconfig)
      modal.show()
    },

    cargarRouter(callback) {
      var self = this,
          idRouter = self.id_router

      RouterSrv.routerJSON(idRouter, { encriptar: 1 }).then(response => {
        let router = response.data
        Object.assign(self.router, router)

        if (callback) callback()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar el router'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    copiarComando: function() {
      const comando = document.getElementById("comando-autoconfig").innerText
      navigator.clipboard.writeText(comando).then(() => {
        iu.msg.success("Comando copiado al portapapeles.")
      }).catch(err => {
        iu.msg.error("Error al copiar: " + err)
      })
    },

    generarComando: function() {
      var self = this

      self.comando = `/tool fetch http-method=get mode=https url="${API}/dmz/routers/${self.router.id}/autoconfig.rsc\\?_d=${self.router._d}" dst-path="autoconfig.rsc"; /import file-name=autoconfig.rsc;`
    }
  }
}
</script>
